/*
 * First Visit Popup jQuery Plugin version 1.2
 * Chris Cook - chris@chris-cook.co.uk
 * Edit by shaddam2011@gmail.com
 */

(function ($) {
  "use strict";

  $.fn.firstVisitPopup = function (settings) {

    console.log(settings.oneDay);

    var setCookie = function (name, value) {
      var date = new Date(),
        expires = "expires=";
      date.setTime(date.getTime() + 86400000);
      expires += date.toGMTString();
      document.cookie = name + "=" + value + "; " + expires + "; path=/";
    };

    var getCookie = function (name) {
      var allCookies = document.cookie.split(";"),
        cookieCounter = 0,
        currentCookie = "";
      for (cookieCounter = 0; cookieCounter < allCookies.length; cookieCounter++) {
        currentCookie = allCookies[cookieCounter];
        while (currentCookie.charAt(0) === " ") {
          currentCookie = currentCookie.substring(1, currentCookie.length);
        }
        if (currentCookie.indexOf(name + "=") === 0) {
          return currentCookie.substring(name.length + 1, currentCookie.length);
        }
      }
      return false;
    };

    var showMessage = function () {
      setCookie("fvpp_" + settings.cookieName, "true");
      setTimeout(function () {
        $('#news-letter-popup').addClass('show');
      }, 100);
    };

    var hideMessage = function () {
      $('#news-letter-popup').removeClass('show');
    };

    if (getCookie("fvpp_" + settings.cookieName) && settings.oneDay == true) {
      hideMessage();
    } else {
      showMessage();
    }

    $('.btn-close').on('click', function () {
      hideMessage();
    });
  };
})(jQuery);
